export default "__VITE_ASSET__4d452c12__"